import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

export default new Router({
    routes: [{
        path: "/",
        name: "login",
        redirect: "/login.do"
    },
        {
            path: "/login.do",
            name: "login",
            component: resolve => require(["./../pages/login/login"], resolve)
        },
        {
            path: "/home.do",
            name: "home",
            component: resolve => require(["./../pages/index/index/index"], resolve),
            meta: {
                leftIndex: "/home.do",
                showMenu: 1,
                title: "巡检人员运行桌面",
            }
        },
        {
            path: "/backIndex.do",
            name: "backIndex",
            component: resolve => require(["./../pages/index/backIndex/index"], resolve),
            meta: {
                leftIndex: "/backIndex.do",
                showMenu: 1,
                title: "收银通管理人员桌面",
            }
        }, {
            path: "/traditionIndex.do",
            name: "traditionIndex",
            component: resolve => require(["./../pages/index/backIndex/traditionIndex"], resolve),
            meta: {
                leftIndex: "/traditionIndex.do",
                showMenu: 1,
                title: "传统管理人员桌面",
            }
        },
        /*消息中心*/
        {
            path: "/messageList.do",
            name: "messageList",
            component: resolve => require(["./../pages/index/message/messageList"], resolve),
            meta: {
                leftIndex: "/messageList.do",
                showMenu: 1,
                title: "消息列表",
            }
        },
//		{
//			path: "/messageinfoDetail.do",
//			name: "messageinfoDetail",
//			component: resolve => require(["./../pages/index/message/messageinfoDetail"], resolve),
//			meta: {
//				leftIndex: 1,
//				showMenu: 1,
//				title: "消息详情",
//			}
//		},
        /*公告列表*/
        {
            path: "/noticeList.do",
            name: "noticeList",
            component: resolve => require(["./../pages/index/notice/noticeList"], resolve),
            meta: {
                leftIndex: "/noticeList.do",
                showMenu: 1,
                title: "公告列表",
            }
        },
        {
            path: "/noticeDetails.do",
            name: "noticeDetails",
            component: resolve => require(["./../pages/index/notice/noticeDetails"], resolve),
            meta: {
                leftIndex: "/noticeDetails.do",
                showMenu: 1,
                title: "公告详情",
            }
        },

        /*商户管理*/
        {
            path: "/merchantManagement.do",
            name: "merchantManagement",
            component: resolve => require(["./../pages/merchantCenter/merchantManagement/merchantManagement"], resolve),
            meta: {
                leftIndex: "/merchantManagement.do",
                showMenu: 2,
                userType: 1,
                title: "收银通商户管理",
                 keepAlive:true
            }
        },
        {
            path: "/merchantSalesManagement.do",
            name: "merchantSalesManagement",
            component: resolve => require(["./../pages/merchantCenter/merchantManagement/merchantSalesManagement"], resolve),
            meta: {
                leftIndex: "/merchantSalesManagement.do",
                showMenu: 2,
                userType: 1,
                title: "收银通销户商户管理",
            }
        },
        {
            path: "/traditionMerchantManagement.do",
            name: "traditionMerchantManagement",
            component: resolve => require(["./../pages/merchantCenter/merchantManagement/traditionMerchantManagement"], resolve),
            meta: {
                leftIndex: "/traditionMerchantManagement.do",
                showMenu: 2,
                userType: 1,
                title: "传统商户管理",
            }
        },
        {
            path: "/traditionSalesAccount.do",
            name: "traditionSalesAccount",
            component: resolve => require(["./../pages/merchantCenter/merchantManagement/traditionSalesAccount"], resolve),
            meta: {
                leftIndex: "/traditionSalesAccount.do",
                showMenu: 2,
                userType: 1,
                title: "销户商户管理",
            }
        },
        {
            path: "/myMerchantManagement.do",
            name: "myMerchantManagement",
            component: resolve => require(["./../pages/merchantCenter/merchantManagement/merchantManagement"], resolve),
            meta: {
                leftIndex: "/myMerchantManagement.do",
                showMenu: 2,
                title: "我的商户",
                userType: 2
            }
        },

        {
            path: "/merchantInformation.do",
            name: "merchantInformation",
            component: resolve => require(["./../pages/merchantCenter/merchantManagement/detail/merchantInformation"], resolve),
            meta: {
                leftIndex: "/merchantManagement.do",
                showMenu: 2,
                title: "查看商户信息",
            }
        },
        {
            path: "/merchantTransaction.do",
            name: "merchantTransaction",
            component: resolve => require(["./../pages/merchantCenter/merchantManagement/detail/merchantTransaction"], resolve),
            meta: {
                leftIndex: "/merchantManagement.do",
                showMenu: 2,
                title: "商户交易查看",
            }
        },
        {
            path: "/businessEquipment.do",
            name: "businessEquipment",
            component: resolve => require(["./../pages/merchantCenter/merchantManagement/detail/businessEquipment"], resolve),
            meta: {
                leftIndex: "/merchantManagement.do",
                showMenu: 2,
                title: "商户设备查看",
            }
        },
        {
            path: "/traditionBbusinessEquipment.do",
            name: "traditionBbusinessEquipment",
            component: resolve => require(["./../pages/merchantCenter/merchantManagement/detail/traditionBbusinessEquipment"], resolve),
            meta: {
                leftIndex: "/traditionMerchantManagement.do",
                showMenu: 2,
                title: "传统商户设备查看",
            }
        },
        {
            path: "/distributionHistory.do",
            name: "distributionHistory",
            component: resolve => require(["./../pages/merchantCenter/merchantManagement/detail/distributionHistory"], resolve),
            meta: {
                leftIndex: "/merchantManagement.do",
                showMenu: 2,
                title: "查看配送历史",
            }
        },
        {
            path: "/inspectionHistory.do",
            name: "inspectionHistory",
            component: resolve => require(["./../pages/merchantCenter/merchantManagement/detail/inspectionHistory"], resolve),
            meta: {
                leftIndex: "/merchantManagement.do",
                showMenu: 2,
                title: "查看巡检历史",
            }
        },
        {
            path: "/merchantToExamine.do",
            name: "merchantToExamine",
            component: resolve => require(["./../pages/merchantCenter/merchantMerchant/merchantToExamine"], resolve),
            meta: {
                leftIndex: 4,
                showMenu: 2,
                title: "商户审核管理",
            }
        },
        {
            path: "/viewAuditingMerchants.do",
            name: "viewAuditingMerchants",
            component: resolve => require(["./../pages/merchantCenter/merchantMerchant/detail/viewAuditingMerchants"], resolve),
            meta: {
                leftIndex: 4,
                showMenu: 2,
                title: "审核商户",
            }
        },
        {
            path: "/policyConfiguration.do",
            name: "policyConfiguration",
            component: resolve => require(["./../pages/merchantCenter/policyConfiguration"], resolve),
            meta: {
                leftIndex: "/policyConfiguration.do",
                showMenu: 2,
                title: "商户等级策略配置",
            }
        },
        {
            path: "/targetMerchant.do",
            name: "targetMerchant",
            component: resolve => require(["./../pages/merchantCenter/targetMerchant/targetMerchant"], resolve),
            meta: {
                leftIndex: "/targetMerchant.do",
                showMenu: 2,
                title: "目标商户管理"
            }
        },
        {
            path: "/targetMerchantDetail.do",
            name: "targetMerchantDetail",
            component: resolve => require(["./../pages/merchantCenter/targetMerchant/detail/targetMerchantDetail"], resolve),
            meta: {
                leftIndex: "/targetMerchant.do",
                showMenu: 2,
                title: "目标商户管理详情",
            }
        },
        {
            path: "/traditionAchievements.do",
            name: "traditionAchievements",
            component: resolve => require(["./../pages/merchantCenter/merchantManagement/traditionAchievements"], resolve),
            meta: {
                leftIndex: "/traditionAchievements.do",
                showMenu: 2,
                title: "传统商户绩效考核管理",
            }
        },
        /*工单管理*/
        {
            path: "/workOrderManagement.do",
            name: "workOrderManagement",
            component: resolve => require(["./../pages/workOrderManagement/workOrderManagement"], resolve),
            meta: {
                leftIndex: "/workOrderManagement.do",
                showMenu: 4,
                userType: 1,
                title: "收银通工单管理",
                keepAlive:true
            }
        },
                {
            path: "/workOrderAudit.do",
            name: "workOrderAudit",
            component: resolve => require(["./../pages/workOrderManagement/workOrderAudit"], resolve),
            meta: {
                leftIndex: "/workOrderAudit.do",
                showMenu: 4,
                userType: 1,
                title: "收银通工单审核",
                keepAlive:true
            }
        },
        {
            path: "/traditionWorkOrderManagement.do",
            name: "traditionWorkOrderManagement",
            component: resolve => require(["./../pages/workOrderManagement/traditionWorkOrderManagement"], resolve),
            meta: {
                leftIndex: "/traditionWorkOrderManagement.do",
                showMenu: 4,
                userType: 1,
                title: "传统工单管理",
                keepAlive:true
            }
        },
        {
            path: "/traditionWorkOrderAudit.do",
            name: "traditionWorkOrderAudit",
            component: resolve => require(["./../pages/workOrderManagement/traditionWorkOrderAudit"], resolve),
            meta: {
                leftIndex: "/traditionWorkOrderAudit.do",
                showMenu: 4,
                userType: 1,
                title: "传统工单审核",
                keepAlive:true
            }
        },
        
        {
            path: "/myWorkOrderManagement.do",
            name: "myWorkOrderManagement",
            component: resolve => require(["./../pages/workOrderManagement/workOrderManagement"], resolve),
            meta: {
                leftIndex: "/myWorkOrderManagement.do",
                showMenu: 4,
                userType: 2,
                title: "巡检-我的工单",
            }
        },

        {
            path: "/orderDetail.do",
            name: "orderDetail",
            component: resolve => require(["./../pages/workOrderManagement/children/orderDetail"], resolve),
            meta: {
                leftIndex: "/workOrderManagement.do",
                showMenu: 4,
                title: "收银通工单详情"
            }
        },
        {
            path: "/traditionOrderDetail.do",
            name: "traditionOrderDetail",
            component: resolve => require(["./../pages/workOrderManagement/children/traditionOrderDetail"], resolve),
            meta: {
                leftIndex: "/traditionWorkOrderManagement.do",
                showMenu: 4,
                title: "传统工单详情",
            }
        },
        {
            path: "/addWorkOrder.do",
            name: "addWorkOrder",
            component: resolve => require(["./../pages/workOrderManagement/children/addWorkOrder"], resolve),
            meta: {
                leftIndex: "/workOrderManagement.do",
                showMenu: 4,
                title: "巡检-工单管理-添加工单",
            }
        },

        /*设备管理*/
        {
            path: "/equipmentTypeManagementTradition.do",
            name: "equipmentTypeManagementTradition",
            component: resolve => require(["./../pages/equipmentCenter/equipmentTypeManagementTradition"], resolve),
            meta: {
                leftIndex: "/equipmentTypeManagementTradition.do",
                showMenu: 3,
                title: "设备型号管理（传统机）",
            }
        },
        {
            path: "/equipmentTypeManagementCashierlink.do",
            name: "equipmentTypeManagementCashierlink",
            component: resolve => require(["./../pages/equipmentCenter/equipmentTypeManagementCashierlink"], resolve),
            meta: {
                leftIndex: "/equipmentTypeManagementCashierlink.do",
                showMenu: 3,
                title: "设备型号管理（收银通）",
            }
        },
        {
            path: "/equipmentTypeTradition.do",
            name: "equipmentTypeTradition",
            component: resolve => require(["./../pages/equipmentCenter/equipmentTypeTradition"], resolve),
            meta: {
                leftIndex: "/equipmentTypeTradition.do",
                showMenu: 3,
                title: "设备类型(传统机)",
            }
        },
        {
            path: "/equipmentTypeCashierlink.do",
            name: "equipmentTypeCashierlink",
            component: resolve => require(["./../pages/equipmentCenter/equipmentTypeCashierlink"], resolve),
            meta: {
                leftIndex: "/equipmentTypeCashierlink.do",
                showMenu: 3,
                title: "设备类型(收银通)",
            }
        },
        {
            path: "/equipmentBrand.do",
            name: "equipmentBrand",
            component: resolve => require(["./../pages/equipmentCenter/equipmentBrand"], resolve),
            meta: {
                leftIndex: "/equipmentBrand.do",
                showMenu: 3,
                title: "设备品牌",
            }
        },
        {
            path: "/equipmentManagementTradition.do",
            name: "equipmentManagementTradition",
            component: resolve => require(["./../pages/equipmentCenter/equipmentManagement/equipmentManagementTradition"], resolve),
            meta: {
                leftIndex: "/equipmentManagementTradition.do",
                showMenu: 3,
                userType: 1,
                title: "设备管理(传统机)",
            }
        },
        {
            path: "/equipmentManagementCashierlink.do",
            name: "equipmentManagementCashierlink",
            component: resolve => require(["./../pages/equipmentCenter/equipmentManagement/equipmentManagementCashierlink"], resolve),
            meta: {
                leftIndex: "/equipmentManagementCashierlink.do",
                showMenu: 3,
                userType: 1,
                title: "设备管理(收银通)",
            }
        },
        {
            path: "/equipmentAdd.do",
            name: "equipmentAdd",
            component: resolve => require(["./../pages/equipmentCenter/equipmentManagement/detail/equipmentAdd"], resolve),
            meta: {
                leftIndex: "/equipmentManagementTradition.do",
                showMenu: 3,
                title: "新增设备",
            }
        },
        {
            path: "/equipmentEdit.do",
            name: "equipmentEdit",
            component: resolve => require(["./../pages/equipmentCenter/equipmentManagement/detail/equipmentEdit"], resolve),
            meta: {
                leftIndex: "/equipmentManagementTradition.do",
                showMenu: 3,
                title: "编辑设备详情",
            }
        },
		{
		    path: "/equipmentAddCashierlink.do",
		    name: "equipmentAddCashierlink",
		    component: resolve => require(["./../pages/equipmentCenter/equipmentManagement/detail/equipmentAddCashierlink"], resolve),
		    meta: {
		        leftIndex: "/equipmentManagementCashierlink.do",
		        showMenu: 3,
		        title: "新增设备",
		    }
		},
		{
		    path: "/equipmentEditCashierlink.do",
		    name: "equipmentEditCashierlink",
		    component: resolve => require(["./../pages/equipmentCenter/equipmentManagement/detail/equipmentEditCashierlink"], resolve),
		    meta: {
		        leftIndex: "/equipmentManagementCashierlink.do",
		        showMenu: 3,
		        title: "编辑设备详情",
		    }
		},
        {
            path: "/consumablesManagement.do",
            name: "consumablesManagement",
            component: resolve => require(["./../pages/equipmentCenter/consumablesManagement"], resolve),
            meta: {
                leftIndex: "/consumablesManagement.do",
                showMenu: 3,
                title: "耗材管理",
            }
        },
                 {
            path: "/replaceEquipmentManagmentCashierlink.do",
            name: "replaceEquipmentManagmentCashierlink",
            component: resolve => require(["./../pages/equipmentCenter/replaceEquipmentManagment/replaceEquipmentManagmentCashierlink"], resolve),
            meta: {
                leftIndex: "/replaceEquipmentManagmentCashierlink.do",
                showMenu: 3,
                title: "收银通替换设备管理",
            }
        },
        {
            path: "/replaceEquipmentManagmentTradition.do",
            name: "replaceEquipmentManagmentTradition",
            component: resolve => require(["./../pages/equipmentCenter/replaceEquipmentManagment/replaceEquipmentManagmentTradition"], resolve),
            meta: {
                leftIndex: "/replaceEquipmentManagmentTradition.do",
                showMenu: 3,
                title: "传统替换设备管理",
            }
        },
        /*报表统计*/
        {
            path: "/businessReport.do",
            name: "businessReport",
            component: resolve => require(["./../pages/reportManagement/businessReport/businessReport"], resolve),
            meta: {
                leftIndex: "/businessReport.do",
                showMenu: 5,
                title: "巡检-报表统计-商户统计报表",
            }
        },
        {
            path: "/terminalRepost.do",
            name: "terminalRepost",
            component: resolve => require(["./../pages/reportManagement/terminalRepost"], resolve),
            meta: {
                leftIndex: "/terminalRepost.do",
                showMenu: 5,
                title: "巡检-报表统计-终端统计报表",
            }
        },
        {
            path: "/workOrderReport.do",
            name: "workOrderReport",
            component: resolve => require(["./../pages/reportManagement/workOrderReport/workOrderReport"], resolve),
            meta: {
                leftIndex: "/workOrderReport.do",
                showMenu: 5,
                title: "巡检-报表统计-工单统计报表",
            }
        },
        {
            path: "/merchantLevel.do",
            name: "merchantLevel",
            component: resolve => require(["./../pages/reportManagement/merchantLevel/merchantLevel"], resolve),
            meta: {
                leftIndex: "/merchantLevel.do",
                showMenu: 5,
                title: "巡检-报表统计-商户等级报表",
            }

        },
        {
            path: "/businessTransactionRecord.do",
            name: "businessTransactionRecord",
            component: resolve => require(["./../pages/reportManagement/businessTransactionRecord"], resolve),
            meta: {
                leftIndex: "/businessTransactionRecord.do",
                showMenu: 5,
                title: "巡检-报表统计-商户交易记录报表",
            }
        },
        {
            path: "/accountingRecordReport.do",
            name: "accountingRecordReport",
            component: resolve => require(["./../pages/reportManagement/accountingRecordReport"], resolve),
            meta: {
                leftIndex: "/accountingRecordReport.do",
                showMenu: 5,
                title: "巡检-报表统计-商户入账记录报表",
            }
        },
        {
            path: "/traditionWorkOrderReport.do",
            name: "traditionWorkOrderReport",
            component: resolve => require(["./../pages/reportManagement/workOrderReport/traditionWorkOrderReport"], resolve),
            meta: {
                leftIndex: "/traditionWorkOrderReport.do",
                showMenu: 5,
                title: "传统工单统计报表",
                  keepAlive:true
                
            }
        },
          {
            path: "/handInDevice.do",
            name: "handInDevice",
            component: resolve => require(["./../pages/reportManagement/handInDevice"], resolve),
            meta: {
                leftIndex: "/handInDevice.do",
                showMenu: 5,
                title: "收银设备上交银行记录",
            }
        },
        {
            path: "/traditionHandInDevice.do",
            name: "traditionHandInDevice",
            component: resolve => require(["./../pages/reportManagement/traditionHandInDevice"], resolve),
            meta: {
                leftIndex: "/traditionHandInDevice.do",
                showMenu: 5,
                title: "传统设备上交银行记录",
            }
        },
        /*用户管理*/
        {
            path: "/userManagement.do",
            name: "userManagement",
            component: resolve => require(["./../pages/userCenter/userManagement"], resolve),
            meta: {
                leftIndex: "/userManagement.do",
                showMenu: 6,
                title: "巡检-用户管理-角色管理",
            }
        },
        {
            path: "/privilegeManagement.do",
            name: "privilegeManagement",
            component: resolve => require(["./../pages/userCenter/privilegeManagement"], resolve),
            meta: {
                leftIndex: "/userManagement.do",
                showMenu: 6,
                title: "巡检-用户管理-权限管理",
            }
        },
        {
            path: "/staffManagement.do",
            name: "staffManagement",
            component: resolve => require(["./../pages/userCenter/staffManagement"], resolve),
            meta: {
                leftIndex: "/staffManagement.do",
                showMenu: 6,
                title: "巡检-用户管理-员工管理",
            }
        },
        {
            path: "/addStaff.do",
            name: "addStaff",
            component: resolve => require(["./../pages/userCenter/detail/addStaff"], resolve),
            meta: {
                leftIndex: "/staffManagement.do",
                showMenu: 6,
                title: "巡检-用户管理-新增员工",
            }
        },
        {
            path: "/editStaff.do",
            name: "editStaff",
            component: resolve => require(["./../pages/userCenter/detail/editStaff"], resolve),
            meta: {
                leftIndex: "/staffManagement.do",
                showMenu: 6,
                title: "巡检-用户管理-编辑员工",
            }
        },
        /*系统管理*/

        {
            path: "/suggestedManagement.do",
            name: "suggestedManagement",
            component: resolve => require(["./../pages/systemManagement/suggestedManagement/suggestedManagement"], resolve),
            meta: {
                leftIndex: "/suggestedManagement.do",
                showMenu: 7,
                title: "巡检-系统管理-商户建议管理",
            }
        },
        {
            path: "/suggestDetail.do",
            name: "suggestDetail",
            component: resolve => require(["./../pages/systemManagement/suggestedManagement/children/suggestDetail"], resolve),
            meta: {
                leftIndex: "/suggestedManagement.do",
                showMenu: 7,
                title: "巡检-系统管理-商户建议详情",
            }
        },
        {
            path: "/messageManagement.do",
            name: "messageManagement",
            component: resolve => require(["./../pages/systemManagement/messageManagement/messageManagement"], resolve),
            meta: {
                leftIndex: "/messageManagement.do",
                showMenu: 7,
                title: "巡检-系统管理-消息管理",
            }
        },
        {
            path: "/messageDetail.do",
            name: "messageDetail",
            component: resolve => require(["./../pages/systemManagement/messageManagement/children/messageDetail"], resolve),
            meta: {
                leftIndex: "/messageManagement.do",
                showMenu: 7,
                title: "巡检-系统管理-消息详情",
            }
        },
        {
            path: "/addMessage.do",
            name: "addMessage",
            component: resolve => require(["./../pages/systemManagement/messageManagement/children/addMessage"], resolve),
            meta: {
                leftIndex: "/messageManagement.do",
                showMenu: 7,
                title: "巡检-系统管理-添加消息",
            }
        },
        {
            path: "/logManagement.do",
            name: "logManagement",
            component: resolve => require(["./../pages/systemManagement/logManagement/logManagement"], resolve),
            meta: {
                leftIndex: "/logManagement.do",
                showMenu: 7,
                title: "巡检-系统管理-日志管理",
            }
        },
        {
            path: "/noticeManagement.do",
            name: "noticeManagement",
            component: resolve => require(["./../pages/systemManagement/noticeManagement/noticeManagement"], resolve),
            meta: {
                leftIndex: "/noticeManagement.do",
                showMenu: 7,
                title: "巡检-系统管理-公告管理",
            }
        },
        {
            path: "/addNotice.do",
            name: "addNotice",
            component: resolve => require(["./../pages/systemManagement/noticeManagement/children/addNotice"], resolve),
            meta: {
                leftIndex: "/noticeManagement.do",
                showMenu: 7,
                title: "巡检-系统管理-添加公告",
            }
        },
        {
            path: "/securityManagement.do",
            name: "securityManagement",
            component: resolve => require(["./../pages/systemManagement/securityManagement/securityManagement"], resolve),
            meta: {
                leftIndex: "/securityManagement.do",
                showMenu: 7,
                title: "巡检-系统管理-安全管理",
            }
        }
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js